export default __webpack_public_path__ + "static/media/fogao_compact_line.ef5c5abc.png";